import { jsx as _jsx } from "react/jsx-runtime";
export function MenuIcon({ className, size }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", height: size + 'px', viewBox: "0 -960 960 960", width: size + 'px', className: className, children: _jsx("path", { d: "M128-251.23v-66h704v66H128ZM128-448v-66h704v66H128Zm0-196.77v-66h704v66H128Z" }) }));
}
//# sourceMappingURL=MenuIcon.js.map